<script lang="ts" module>
  import { onDestroy } from 'svelte';

  import type { TeoText } from '@/teoCore/text/TeoText';
  import {
    BrandFitCategories,
    type BrandFitCategory,
  } from '@/teoCore/text/WordListHandler/BrandFitHandler';
  import TpiDrawer from '@/ui/elements/tpi-drawer/TPIDrawer.svelte';
  import { useTeoTextUiStateObserver } from '@/utils/use-teo-event-observer.svelte';

  import { createBrandFitPillGroups, type BrandFitPillGroup } from './BrandFitComponent';

  export interface BrandFitComponentProps {
    teoText: TeoText;
  }
</script>

<script lang="ts">
  let { teoText }: BrandFitComponentProps = $props();
  const dimensionDrawerOpen = useTeoTextUiStateObserver(teoText.ui, 'dimensionDrawerOpen');
  const category = useTeoTextUiStateObserver(teoText.ui, 'brandFitCategory');
  const wordListName = useTeoTextUiStateObserver(teoText.ui, 'brandFitWordList');

  let pillgroups: BrandFitPillGroup[] = $state([]);

  onScan();

  teoText.wordLists.events.addEventListener('gotScanResult', onScan);

  onDestroy(() => {
    teoText.wordLists.events.removeEventListener('gotScanResult', onScan);
  });

  function onScan() {
    pillgroups = createBrandFitPillGroups(teoText.wordLists.brandFit);
  }

  function onDimensionChange(dm: string | undefined) {
    if (dm === undefined || (BrandFitCategories as readonly string[]).includes(dm))
      teoText.ui.update('brandFitCategory', dm as BrandFitCategory);
  }

  function onTextPropertyChange(tp: string | undefined) {
    teoText.ui.update('brandFitWordList', tp);
  }
</script>

<TpiDrawer
  open={dimensionDrawerOpen.current}
  pillGroups={pillgroups}
  useableSubdims={['subdim4', 'subdim5']}
  dimension={category.current}
  textProperty={wordListName.current}
  helpTopicName="brand-fit"
  {onDimensionChange}
  {onTextPropertyChange}
></TpiDrawer>
